import ApiTableRow from './ApiTableRow'

import type {PropertyDescription} from '../apiList'

export type TableRow = {
    value: string
    type: string
}

export type TableSpanRowProps = {
    title: string
    rowSpan?: number
    parent?: TableRow
} & PropertyDescription

export default function ApiTableSpanRow({value, type, rowSpan, title, parent}: TableSpanRowProps) {
    return typeof value == 'string'
        ? <ApiTableRow value={value} type={type} rowSpan={rowSpan} title={title} parent={parent}/>
        : Object.entries(value).map(([key, {value: subValue, type: subType}], index) =>
            <ApiTableSpanRow
                key={key}
                value={subValue}
                type={subType}
                title={key}
                rowSpan={index ? undefined : Object.keys(value).length}
                parent={{value: title, type}}
            />
        )
}
